import { render } from "./about-top.vue?vue&type=template&id=dc2105fe&ts=true"
import script from "./about-top.vue?vue&type=script&lang=ts"
export * from "./about-top.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__